import { render, staticRenderFns } from "./working_wall_detail.vue?vue&type=template&id=53b88834&scoped=true"
import script from "./working_wall_detail.vue?vue&type=script&lang=js"
export * from "./working_wall_detail.vue?vue&type=script&lang=js"
import style0 from "./working_wall_detail.vue?vue&type=style&index=0&id=53b88834&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b88834",
  null
  
)

export default component.exports